module.exports = "<h2 class=\"page-header\">Brands</h2>\n<button type=\"button\" routerLink=\"/agora/product-data/brands/add\" class=\"nav-btn btn btn-primary\">\n    <span class=\"fa fa-plus\"></span> New\n</button>\n<div class=\"clear\"></div>\n<itpx-dynamic-grid\n    [fields]=\"fields\"\n    [url]=\"url\"\n    [refresh]=\"gridRefresh\"\n    [config]=\"{useDollarPrefixConvention: true}\"></itpx-dynamic-grid>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/product-data/brands/brands.component.html
// module id = ./src/app/agora/components/product-data/brands/brands.component.html
// module chunks = main